import { Icon } from "web/components"

export default function SelectionSummary({ selected, onSelectionChanged }) {
  function handleRemoveSelection(selectedEl) {
    onSelectionChanged({ ...selectedEl, selected: false })
  }

  const otherSelected = selected.length > 5 ? selected.length - 5 : 0

  return (
    <div className="w-64 rounded-md bg-white text-xs shadow-altrio-1">
      <div className="rounded-t-md bg-neutral-9 p-2 text-neutral-2">
        Selected
      </div>
      <div className="py-1 text-2xs">
        {selected.slice(0, 5).map((selectedEl) => (
          <div
            key={selectedEl.id}
            className="flex items-center space-x-1 px-2 py-1"
          >
            <span
              className="cursor-pointer"
              onClick={() => handleRemoveSelection(selectedEl)}
            >
              <Icon name="x-mark" width="15px" height="15px" className="mr-2" />
            </span>
            <span>{selectedEl.name}</span>
          </div>
        ))}
        {otherSelected !== 0 && (
          <div className="px-2 py-1">{`${otherSelected} other${
            otherSelected > 1 ? "s" : ""
          }`}</div>
        )}
      </div>
    </div>
  )
}
